/*
  SMANT: bestelblok op vloerpagina's. Zet het blok uit snippets/smant-bestelblok.liquid voor de
  In winkelwagen-knop, rekent live met window.SmantBestel (assets/smant-bestel-core.js) en
  opent na "In winkelwagen" de optiewizard. Zonder dit script blijft de standaard themaprijs
  en -knop staan.
*/
(function () {
  'use strict';

  var B = window.SmantBestel;
  if (!B) return;

  var cfg, state, block, input, atcButton;

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function readConfig() {
    var raw = JSON.parse($('#sb_config').textContent);
    raw.packM2 = B.parseMeasure(raw.packM2);
    raw.plintBoardM = B.parseMeasure(raw.plintBoardM) || 2.4;
    raw.wastePct = Number(raw.wastePct);
    if (isNaN(raw.wastePct)) raw.wastePct = 11;
    if (!raw.perM2Cents) raw.perM2Cents = raw.packM2 > 0 ? Math.round(raw.unitCents / raw.packM2) : raw.unitCents;
    return raw;
  }

  function currentCalc() {
    return B.calcFloor({ m2: input.value, useWaste: state.useWaste, wastePct: cfg.wastePct, packM2: cfg.packM2, unitCents: cfg.unitCents });
  }

  function showError(msg) {
    var el = $('.sb_error', block);
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function renderPrice() {
    $('.sb_perm2', block).innerHTML = B.euro(cfg.perM2Cents) + ' <small>per m²</small>';
    var pak = $('.sb_perpak', block);
    if (cfg.packM2 > 0) pak.textContent = B.euro(cfg.unitCents) + ' per pak van ' + B.fmtNum(cfg.packM2) + ' m² · incl. btw';
    else pak.textContent = 'Incl. btw';
  }

  function render() {
    var c = currentCalc();
    var result = $('.sb_result', block);
    var total = $('.sb_total_val', block);
    var tax = $('.sb_tax', block);
    if (!c.entered) {
      result.hidden = true;
      total.textContent = 'Vul je m² in';
      total.classList.add('is_empty');
      tax.hidden = true;
      return c;
    }
    if (c.mode === 'pack') {
      var waste = state.useWaste
        ? 'Inclusief ' + B.fmtNum(cfg.wastePct) + '% snijverlies: ' + B.fmtNum(c.areaIncl) + ' m² · '
        : 'Zonder snijverlies · ';
      result.innerHTML =
        waste + 'Je krijgt <strong>' + c.packs + (c.packs === 1 ? ' pak' : ' pakken') + '</strong> (' + B.fmtNum(c.totalArea) + ' m²) ' +
        '<button type="button" class="sb_waste_toggle">' + (state.useWaste ? 'zonder snijverlies rekenen' : 'met snijverlies rekenen') + '</button>';
    } else {
      result.innerHTML = 'Je bestelt <strong>' + c.qty + ' m²</strong>';
    }
    result.hidden = false;
    total.textContent = B.euro(c.totalCents);
    total.classList.remove('is_empty');
    tax.hidden = false;
    if (c.valid) showError('');
    return c;
  }

  function step(delta) {
    var v = B.parseNum(input.value);
    if (isNaN(v)) v = delta > 0 ? B.MIN_M2 - 1 : B.MIN_M2 + 1;
    v = Math.max(1, Math.round(v) + delta);
    input.value = String(v);
    render();
  }

  var wiz = { el: null, index: 0, busy: false, lastFocus: null };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function option(name, value, checked, label, sub) {
    return (
      '<label class="sbw_option"><input type="radio" name="' + name + '" value="' + value + '"' + (checked ? ' checked' : '') + '>' +
      '<span>' + esc(label) + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span></label>'
    );
  }

  function field(cls, label, value, placeholder) {
    return '<label class="sbw_field">' + esc(label) + '<input type="text" inputmode="decimal" autocomplete="off" class="' + cls + '" value="' + esc(value) + '" placeholder="' + esc(placeholder) + '"></label>';
  }

  var STEP = {
    legservice: function (a, c) {
      var m2c = Math.ceil(c.m2 - B.EPS);
      return {
        title: 'Zullen wij je vloer leggen?',
        body:
          '<p class="sbw_info">Wij leggen je vloer. Inbegrepen: inmeten vooraf, ondervloer leggen, plinten plaatsen en afvoer van snijafval.</p>' +
          '<p class="sbw_price">' + B.euro(cfg.legservice.priceCents) + ' per m² · <strong>' + B.euro(m2c * cfg.legservice.priceCents) + '</strong> voor ' + m2c + ' m²</p>' +
          '<div class="sbw_options">' +
          option('sbw_ls', 'ja', a.legservice === 'ja', 'Ja, ik wil graag mijn vloeren laten leggen') +
          option('sbw_ls', 'nee', a.legservice === 'nee', 'Ik leg de vloer zelf') +
          option('sbw_ls', 'advies', a.legservice === 'advies', 'Weet ik nog niet', 'We nemen contact met je op, er wordt niets extra gerekend') +
          '</div>',
      };
    },
    plinten: function (a) {
      var p = a.plinten;
      var lsYes = cfg.isBundle || a.legservice === 'ja';
      var html = '<div class="sbw_options">';
      html += option('sbw_pl', 'advies', p.choice === 'advies', 'Ja, kies voor mij bijpassende plint', 'We nemen contact met je op, er wordt nu niets gerekend');
      if (cfg.plinten.length) html += option('sbw_pl', 'type', p.choice === 'type', 'Ja, ik kies een type');
      html += option('sbw_pl', 'nee', p.choice === 'nee', 'Nee, geen plinten') + '</div>';
      if (p.choice === 'type') {
        html += '<div class="sbw_plints">' + cfg.plinten.map(function (o) {
          return '<label class="sbw_plint"><input type="radio" name="sbw_plint" value="' + o.variantId + '"' + (Number(p.variantId) === o.variantId ? ' checked' : '') + '>' +
            (o.img ? '<img src="' + esc(o.img) + '" alt="" width="48" height="48" loading="lazy">' : '') +
            '<span>' + esc(o.name) + '</span><strong>' + B.euro(o.priceCents) + ' per plank</strong></label>';
        }).join('') + '</div>';
      }
      if (p.choice === 'type' || p.choice === 'advies') {
        html += field('sbw_meters', 'Wandlengte in meters (alle wanden samen)', p.meters, 'bijv. 18');
        var m = B.parseNum(p.meters);
        if (p.choice === 'type' && !isNaN(m) && m > 0) {
          html += '<p class="sbw_note">' + Math.ceil(m / cfg.plintBoardM - B.EPS) + ' planken van ' + B.fmtNum(cfg.plintBoardM) + ' m</p>';
        }
      }
      if (lsYes && p.choice && p.choice !== 'nee') html += '<p class="sbw_note">Plaatsen is inbegrepen bij de leg service.</p>';
      return { title: 'Wil je er plinten bij?', body: html };
    },
    inloopmat: function (a) {
      var m = a.inloopmat;
      var html =
        '<p class="sbw_info">We snijden een inloopmat precies op maat voor je entree. De prijs volgt na het inmeten, er wordt nu niets gerekend.</p>' +
        '<div class="sbw_options">' + option('sbw_mat', 'ja', m.choice === 'ja', 'Ja, graag') + option('sbw_mat', 'nee', m.choice === 'nee', 'Nee, dank je') + '</div>';
      if (m.choice === 'ja') html += '<div class="sbw_fields">' + field('sbw_w', 'Breedte (cm)', m.w, 'bijv. 90') + field('sbw_l', 'Lengte (cm)', m.l, 'bijv. 150') + '</div>';
      return { title: 'Inloopmat op maat?', body: html };
    },
    overzicht: function (a, c) {
      var o = B.buildOrder(cfg, c, a);
      return {
        title: 'Je bestelling',
        body:
          '<table class="sbw_lines"><tbody>' + o.lines.map(function (l) {
            return '<tr><td>' + esc(l.label) + '<small>' + esc(l.detail) + '</small></td><td>' + (l.cents == null ? 'Volgt' : l.cents === 0 ? 'Inbegrepen' : B.euro(l.cents)) + '</td></tr>';
          }).join('') + '</tbody></table>' +
          '<p class="sbw_total"><span>Totaal incl. btw</span><span>' + B.euro(o.totalCents) + '</span></p>',
      };
    },
  };

  function list() {
    return B.steps(cfg, state.answers);
  }

  function renderStep() {
    var keys = list();
    if (wiz.index > keys.length - 1) wiz.index = keys.length - 1;
    var key = keys[wiz.index];
    var view = STEP[key](state.answers, currentCalc());
    $('.sbw_step', wiz.el).textContent = 'Stap ' + (wiz.index + 1) + ' van ' + keys.length;
    $('.sbw_title', wiz.el).textContent = view.title;
    $('.sbw_body', wiz.el).innerHTML = view.body;
    $('.sbw_back', wiz.el).hidden = wiz.index === 0;
    $('.sbw_next', wiz.el).textContent = key === 'overzicht' ? 'Toevoegen aan winkelwagen' : 'Volgende';
    setWizError('');
  }

  function setWizError(msg) {
    var el = $('.sbw_error', wiz.el);
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  /* Leest de velden van de huidige stap in state.answers. Bij een radio-wissel volgt een nieuwe render. */
  function onWizInput(e) {
    var a = state.answers;
    var t = e.target;
    if (t.name === 'sbw_ls') a.legservice = t.value;
    else if (t.name === 'sbw_pl') a.plinten.choice = t.value;
    else if (t.name === 'sbw_plint') a.plinten.variantId = Number(t.value);
    else if (t.name === 'sbw_mat') a.inloopmat.choice = t.value;
    else if (t.classList.contains('sbw_meters')) a.plinten.meters = t.value;
    else if (t.classList.contains('sbw_w')) a.inloopmat.w = t.value;
    else if (t.classList.contains('sbw_l')) a.inloopmat.l = t.value;
    if (t.type === 'radio') {
      renderStep();
      /* renderStep vervangt de inhoud; zet de focus terug, anders valt hij naar <body> en werken pijltjestoetsen niet meer. */
      var field = (t.name === 'sbw_pl' || t.name === 'sbw_mat') && $('.sbw_meters, .sbw_w', wiz.el);
      var same = wiz.el.querySelector('input[name="' + t.name + '"]:checked');
      if (field) field.focus();
      else if (same) same.focus();
    } else if (t.classList.contains('sbw_meters') && a.plinten.choice === 'type') {
      var note = $('.sbw_note', wiz.el);
      var m = B.parseNum(t.value);
      if (note && !isNaN(m) && m > 0) note.textContent = Math.ceil(m / cfg.plintBoardM - B.EPS) + ' planken van ' + B.fmtNum(cfg.plintBoardM) + ' m';
    }
  }

  function next() {
    var keys = list();
    var key = keys[wiz.index];
    var err = B.validateStep(key, cfg, state.answers);
    if (err) return setWizError(err);
    if (key === 'overzicht') return addToCart();
    wiz.index += 1;
    renderStep();
    $('.sbw_title', wiz.el).focus();
  }

  function back() {
    if (wiz.index === 0) return;
    wiz.index -= 1;
    renderStep();
    $('.sbw_title', wiz.el).focus();
  }

  function closeWizard() {
    if (wiz.busy) return;
    wiz.el.hidden = true;
    document.documentElement.style.overflow = '';
    if (wiz.lastFocus) wiz.lastFocus.focus();
  }

  function trapFocus(e) {
    if (e.key === 'Escape') return closeWizard();
    if (e.key !== 'Tab') return;
    var f = [].filter.call(wiz.el.querySelectorAll('button, input, a[href]'), function (n) {
      return !n.disabled && n.offsetParent !== null;
    });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }

  function addToCart() {
    if (wiz.busy) return;
    wiz.busy = true;
    var btn = $('.sbw_next', wiz.el);
    btn.disabled = true;
    btn.textContent = 'Bezig met toevoegen...';
    var form = document.querySelector('main-product form[action*="/cart/add"]');
    var vid = form && form.querySelector('[name="id"]');
    if (vid) cfg.floorVariantId = Number(vid.value);
    var order = B.buildOrder(cfg, currentCalc(), state.answers);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: order.items }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw d; });
        /* Vanaf hier staat alles al in de winkelwagen: een mislukte verversing is geen fout, anders voegt een tweede klik alles dubbel toe. */
        return fetch(root + '?sections=cart-drawer,cart,cart-bubble')
          .then(function (s) { return s.json(); })
          .catch(function () { return null; });
      })
      .then(function (sections) {
        wiz.busy = false;
        closeWizard();
        var drawer = document.querySelector('.cart_drawer_wrapper');
        if (!sections || !drawer || typeof window.openDrawer !== 'function') {
          window.location.href = root + 'cart';
          return;
        }
        document.dispatchEvent(new CustomEvent('cart-updated', { detail: { sections: sections }, bubbles: true }));
        window.openDrawer(drawer, atcButton);
        if (typeof window.AddScrollLock === 'function') window.AddScrollLock();
      })
      .catch(function (d) {
        wiz.busy = false;
        setWizError((d && d.description) || 'Toevoegen is niet gelukt. Probeer het opnieuw of bel ons op 050 312 8731.');
        btn.disabled = false;
        btn.textContent = 'Toevoegen aan winkelwagen';
      });
  }

  function openWizard() {
    wiz.el = wiz.el || $('#sbw');
    if (!wiz.el.dataset.bound) {
      wiz.el.dataset.bound = '1';
      document.body.appendChild(wiz.el);
      wiz.el.addEventListener('click', function (e) {
        if (e.target.closest('[data-sbw-close]')) closeWizard();
        else if (e.target.closest('.sbw_next')) next();
        else if (e.target.closest('.sbw_back')) back();
      });
      wiz.el.addEventListener('change', onWizInput);
      wiz.el.addEventListener('input', function (e) { if (e.target.type !== 'radio') onWizInput(e); });
      wiz.el.addEventListener('keydown', trapFocus);
    }
    wiz.lastFocus = document.activeElement;
    wiz.index = 0;
    renderStep();
    wiz.el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    $('.sbw_title', wiz.el).focus();
  }

  function onAtcClick(e) {
    /* Alle knoppen binnen main-product, ook de vaste knop onderin beeld (sticky add-to-cart). */
    var btn = e.target.closest && e.target.closest('.product_form_submit_btn');
    if (!btn || !btn.closest('main-product')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var c = render();
    if (!c.valid) {
      showError('Vul minimaal ' + B.MIN_M2 + ' m² in om te bestellen.');
      input.focus();
      return;
    }
    openWizard();
  }

  function place() {
    var main = document.querySelector('main-product');
    atcButton = main && main.querySelector('.product_form_submit_btn');
    var atcWrap = main && main.querySelector('.main_product_add_to_cart_btn_wrapper');
    if (!atcButton || !atcWrap) return false;
    [].forEach.call(main.querySelectorAll('.main_product_price_wrapper, .main_product_quantity_wrapper'), function (el) {
      el.style.display = 'none';
    });
    atcWrap.parentNode.insertBefore(block, atcWrap);
    var showroom = $('#sb_showroom');
    if (showroom && showroom.querySelector('.sb_showroom_btn')) {
      /* In winkelwagen en de showroomknop naast elkaar, elk de halve breedte. */
      var actions = document.createElement('div');
      actions.className = 'sb_actions';
      atcWrap.parentNode.insertBefore(actions, atcWrap);
      actions.appendChild(atcWrap);
      actions.appendChild(showroom);
      showroom.hidden = false;
    }
    atcButton.disabled = false;
    block.hidden = false;
    return true;
  }

  function init() {
    block = $('#sb');
    if (!block || !$('#sb_config')) return;
    cfg = readConfig();
    state = { useWaste: true, answers: B.emptyAnswers() };
    input = $('#sb_m2', block);
    if (!place()) return;
    renderPrice();
    render();
    input.addEventListener('input', render);
    $('.sb_minus', block).addEventListener('click', function () { step(-1); });
    $('.sb_plus', block).addEventListener('click', function () { step(1); });
    block.addEventListener('click', function (e) {
      if (e.target.closest('.sb_waste_toggle')) {
        state.useWaste = !state.useWaste;
        render();
      }
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        atcButton.click();
      }
    });
    document.addEventListener('click', onAtcClick, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
